<div class="billing-information">
  <div class="title">Billing Address</div>
  <form class="content" [formGroup]="form">
    <div class="form-row" *ngFor="let formField of formFields">
      <form-field [formField]="formField" [form]="form"></form-field>
    </div>
  </form>
</div>
